import { usePathname, useSearchParams } from 'next/navigation';

// https://www.notion.so/IP-Ban-User-Improvement-v1-1-3a20f14fc1064693a58e6681dcbe02ab
export function useTemporaryAllowPage() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return pathname.includes('/signup') && !!searchParams.get('hash');
}
